export default function toCamelCase(text: string): string {
  const result = toCapitalizedCamelCase(text);
  return result.substring(0, 1).toLowerCase() + result.substring(1);
}

function toCapitalizedCamelCase(text: string): string {
  return text.replace(/[-_\s.]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ""));
}
